import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress"; //顶部页面加载条
import "nprogress/nprogress.css"; //顶部页面加载条css
import pages from "./pages";

import { Message, Loading } from "element-ui";
var isPro = process.env.NODE_ENV === "production";

import store from "@/store";

import { getLoginUser } from "@/api/login/login";
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3,
});
Vue.use(VueRouter);
//基本路由
const login = () => import("@/views/login/index.vue"); //登陆页
const layout = () => import("@/views/layout/index.vue"); //总体布局
const home = () => import("@/views/home/index.vue"); //首页
const indexView = () => import("@/views/home/indexView.vue"); //监控首页
const safeAccess = () => import("@/views/Venue_setting/safe-Access.vue"); //微信小程序出入场页面
const err404 = () => import("@/views/error/404"); //404

const filePreview = () => import("@/components/filePreview/index.vue");//文件预览页面

const routes = [
  { path: "/login", name: "login", component: login, meta: { title: "登陆" } }, //登陆
  {
    path: "/homeView",
    name: "homeView",
    component: indexView,
    meta: { title: "监控平台", keepAlive: false, hasPermission: false },
  }, //监控平台
  {
    path: "/safeAccess",
    name: "safeAccess",
    component: safeAccess,
    meta: { title: "出入场登记", hasPermission: false },
  }, //微信出入场
  {
    path: "/filePreview",
    name: "filePreview",
    component: filePreview,
    meta: { title: "文件预览", hasPermission:false, },
  }, //文件预览
  {
    path: "/404",
    component: () => import("@/views/error/404"),
    meta: { title: "404", keepAlive: false, hasPermission: false },
    hidden: true,
  },

  {
    path: "/",
    name: "",
    hasPermission: false,
    meta: { hasPermission: false },
    redirect: "/home",
    component: layout, //布局文件
    children: [
      {
        path: "/home",
        name: "home",
        component: home,
        meta: { title: "首页", hasPermission: false },
      }, //首页
      ...pages, //TODO:导入页面文件
    ],
  },

  //放在所有路由后面，不然会样式污染，未找到原因。
  {
    path: "/err404",
    name: "err404",
    component: err404,
    meta: { title: "404", hasPermission: false },
  }, //404

  //这个*匹配必须放在最后，将改路由配置放到所有路由的配置信息的最后，否则会其他路由path匹配造成影响。
  { path: "*", redirect: "/404", hidden: true, meta: { hasPermission: false } },
];

const router = new VueRouter({
  //开启哈希模式
  //   mode: "history",
  routes,
});

// TODO: 路由守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start(); //开启顶部进度条
  // if(window.location.hash == "/#"){
  //   return toWeb()
  // }
  //获取主系统传入的token
  const hash = window.location.hash;
  const tokenMatch = hash.match(/token=([^&]*)/);
  const token = tokenMatch ? tokenMatch[1] : null;
  console.log(token, "token!token!token!token!token!token!");

//判断是不是进出场路由
  if (to.path == "/safeAccess" || to.path == "/safeRiskcard") {
    return next();
  }
  if (token) {
    // 清除 localStorage 中的特定项
    const itemsToKeep = ["layout-setting"]; // 需要保留的项
    const keysToRemove = Object.keys(localStorage).filter(
      (key) => !itemsToKeep.includes(key)
    );
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    // localStorage.clear(); //移除所有缓存

    // 获取第三方用户信息
    let res = await getLoginUser(token);
    console.log(res, "第三方用户信息");
    if (res.code == 200) {
      console.log("单点登录成功！！！！！！");
    }
    
    // 使用 replaceState 来移除查询参数
      history.replaceState(null, "", `/#${to.path}`);
      
      console.log(token, "主系统的token");
  }

  const tokenStr = window.localStorage.getItem("Authorization");
  //标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "安全管理系统"; //此处写默认的title
  }
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // 访问登录页面 直接放行
  // if (to.path === "/login" || to.path === "/safeAccess") return next();
  // 没有token， 强制转到login页面
  if (!tokenStr){ 
    return toWeb(to.path)
    // return next("/login");
  
  }


  if (to.meta.hasOwnProperty("hasPermission") && to.meta.hasPermission == false)
    return next();

  // 判断是否拥有跳转页面权限
  // const hasPermission = checkPermission(store.state.roleArr, to.path);
  // console.log(hasPermission, "是否拥有权限", to.path);
  // if (hasPermission) {
  //   next();
  // } else {
  //   store.commit("delete_tabs", to.path);
  //   console.log(hasPermission,'权限！！！！！！！！！！！！！！！！！！！！！！！！！');
  //   // 没有权限,提示错误信息或跳转到 403 页面
  //   // 这里可以根据实际需求进行处理
  //   next("/404");
  // }
  
  next();
});

//
function toWeb(path){
  console.log(path);
  let ip = isPro?"120.79.80.25":"localhost";
  // Message({
  //   message: '登录状态已过期，请重新登录！',
  //   type: "error",
  //   duration: 3 * 1000,
  // });
  setTimeout(()=>{
  window.location.href = `http://120.79.47.146:20806/#/login?ExternalLinks=http://${ip}:9600/#${path}`;
  },300)
}
// 检查用户是否有访问某个路由的权限
function checkPermission(data, path) {
  // 根据实际需求,编写权限判断的逻辑
  // 这里只是一个示例,实际需要根据您的业务逻辑进行实现
  for (let item of data) {
    if (item.path == path) {
      return true;
    }
    if (item.children && item.children.length > 0) {
      if (checkPermission(item.children, path)) {
        return true;
      }
    }
  }
  return false;
}

//路由跳转结束
router.afterEach(() => {
  NProgress.done(); //关闭顶部进度条
});

//解决重复点击当前路由跳转时报错信息。原因是vue-cli版本BUG，3.0版本无此BUG，往上时需要添加以下方法。
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
export default router;
